/* corex-textil-editor-fonts.js · Fuentes de Google Fonts para los textos del personalizador de camisetas.
   Carga bajo demanda: los botones usan un recorte con solo las letras de su nombre (parámetro text=) y la fuente
   completa se carga al elegirla. Cada fuente se registra con un alias propio ("cte-inter") para no mezclarse con
   las del tema ni con su recorte. ensure() espera a que la fuente esté lista antes de medir o generar el PNG. */
(function (global) {
  'use strict';

  var CSS_API = 'https://fonts.googleapis.com/css2?family=';
  var SAMPLE_PX = 40;
  var FONTS = [
    ['Inter', 700], ['Bricolage Grotesque', 700], ['Geist', 700], ['Big Shoulders', 800], ['Figtree', 700],
    ['Manrope', 700], ['Space Grotesk', 700], ['Playfair Display', 700, 'serif'], ['Fraunces', 700, 'serif'],
    ['Outfit', 700], ['Hanken Grotesk', 700], ['Oswald', 600], ['Bebas Neue', 400], ['Montserrat', 700],
    ['Anton', 400], ['Raleway', 700], ['Open Sans', 700], ['Lato', 700], ['Poppins', 600], ['Work Sans', 700],
    ['Rubik', 700], ['Merriweather', 700, 'serif'], ['Archivo Black', 400], ['Teko', 600], ['Barlow Condensed', 700],
    ['Black Ops One', 400], ['Permanent Marker', 400, 'cursive'], ['Pacifico', 400, 'cursive']
  ].map(function (f) {
    var key = f[0].toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var alias = 'cte-' + key;
    return { key: key, name: f[0], weight: f[1], alias: alias, family: '"' + alias + '", ' + (f[2] || 'sans-serif') };
  });
  /* Las 8 que se ven sin desplegar (las de la propuesta) y la de los textos nuevos. */
  var QUICK = ['bebas-neue', 'anton', 'oswald', 'montserrat', 'poppins', 'inter', 'archivo-black', 'teko'];
  var DEFAULT_KEY = 'bebas-neue';
  var byKey = FONTS.reduce(function (acc, f) { acc[f.key] = f; return acc; }, {});

  function get(key) { return byKey[key] || null; }
  function cssUrl(f, text) {
    return CSS_API + encodeURIComponent(f.name).replace(/%20/g, '+') + ':wght@' + f.weight + '&display=block' +
      (text ? '&text=' + encodeURIComponent(text) : '');
  }
  /* CSS de Google con el nombre de familia cambiado por el alias. */
  function aliasCss(css, f, alias) {
    return String(css).replace(/font-family:\s*'[^']*'/g, "font-family: '" + alias + "'");
  }

  var cssDone = {}, loads = {}, ready = {};
  function injectCss(url, f, alias) {
    if (cssDone[url]) return cssDone[url];
    cssDone[url] = fetch(url).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (css) {
      var style = document.createElement('style');
      style.setAttribute('data-cte-font', alias);
      style.textContent = aliasCss(css, f, alias);
      document.head.appendChild(style);
    });
    cssDone[url].catch(function () { delete cssDone[url]; });
    return cssDone[url];
  }
  /* Recorte con las letras del nombre, para pintar el botón de la fuente con su tipografía. */
  function loadPreview(key) {
    var f = get(key);
    if (!f) return Promise.resolve();
    var alias = f.alias + '-p';
    return injectCss(cssUrl(f, f.name), f, alias).then(function () {
      return document.fonts.load(f.weight + ' ' + SAMPLE_PX + 'px "' + alias + '"', f.name);
    });
  }
  function previewFamily(key) { var f = get(key); return f ? '"' + f.alias + '-p", ' + f.family : 'inherit'; }
  /* Fuente completa lista para medir y dibujar `text` (incluidos acentos y ñ). Rechaza con un error para el cliente. */
  function ensure(key, text) {
    var f = get(key);
    if (!f) return Promise.resolve();
    var id = key + '|' + (text || '');
    if (!loads[id]) {
      loads[id] = injectCss(cssUrl(f), f, f.alias).then(function () {
        return document.fonts.load(f.weight + ' ' + SAMPLE_PX + 'px "' + f.alias + '"', text || f.name);
      }).then(function (faces) {
        if (!faces || !faces.length) throw new Error('sin caras');
        ready[key] = true;
      }).catch(function () {
        delete loads[id];
        throw Object.assign(new Error('No se ha podido cargar la fuente «' + f.name + '». Revisa tu conexión e inténtalo de nuevo.'), { userFacing: true });
      });
    }
    return loads[id];
  }
  /* La fuente completa ya se ha cargado alguna vez (document.fonts.check no sirve: da true con familias sin cargar). */
  function isReady(key) { return !get(key) || !!ready[key]; }
  /* Todas las fuentes de unas capas de texto, con su texto. */
  function ensureLayers(layers) {
    return Promise.all((layers || []).filter(function (l) { return l.type === 'text'; }).map(function (l) { return ensure(l.fontKey, l.text); }));
  }

  global.CorexTextilFonts = {
    FONTS: FONTS, QUICK: QUICK, DEFAULT_KEY: DEFAULT_KEY, get: get, cssUrl: cssUrl, aliasCss: aliasCss,
    loadPreview: loadPreview, previewFamily: previewFamily, ensure: ensure, isReady: isReady, ensureLayers: ensureLayers
  };
})(this);
